export default __webpack_public_path__ + "static/media/volume.de20a608.svg";